import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from './services/loader.service'
import { ShopService } from './services/shop.service'
import { TrakiiLoginService } from './services/trakiilogin.service';
import { LensDispatchLoginService } from './services/lensdispatchlogin.service';

import { UserService } from './services/user.service';
import { map, Observable } from 'rxjs';
    

@Component({
    selector: 'app-shop',
    templateUrl: '/shoplanding.html'
})
export class ShopLandingComponent {
    loading: boolean;
  myDataShop: any;
  title: string;
  shopKey: string;
  shopName: string;

  shop: any;
  userName: string;
  store: any;
  sla: string;
  remember = false

  slaInternal: string;

  doPopUp = false;
  userRole: string;
  siteInfo = false;

  isLensDispatch = false;
  constructor(public http: HttpClient, private loaderService: LoaderService, private shopService: ShopService, public trakiiLoginService: TrakiiLoginService, public lensdispatchLoginService: LensDispatchLoginService, private route: ActivatedRoute, private userService: UserService,) { 
      
        shopService.changeEmitted$.subscribe(
            myString => {
                //console.log('xx' + myString);
                this.shop = myString;

          });


        this.isCsTeam().subscribe(isTeam => {
         this.isLensDispatch = isTeam
        });

    }

  dspAdmiNote = false;
  getShopLocal(shop: string) {
    this.loaderService.emitChange(true)
    var myUrl: string = '/Shopping/Shop?shop=' + shop;
    this.http.get(myUrl)
      .subscribe((res: any) => {
        this.loaderService.emitChange(false);
        this.myDataShop = res[0];
        this.store = this.myDataShop?.Store
        this.sla = this.myDataShop?.Sla
        this.remember = this.myDataShop?.remember
        this.siteInfo = this.myDataShop?.InNightAudit;

  
        // let myNotShops = ['0039',
        //   '0123',
        //   '0143',
        //   '0157',
        //   '0214',
        //   '0219',
        //   '0312',
        //   '0434',
        //   '0464',
        //   '0468',
        //   '0642',
        //   '0755',
        //   '0801',
        //   '1114',
        //   '1207',
        //   '1222',
        //   '1278',
        //   '1285',
        //   '1354',
        //   '1363',
        //   '1468',
        //   '1469',
        //   '1548',
        //   '1556',
        //   '1620',
        //   '1640',
        //   '1841',
        //   '1977',
        //   '2008',
        //   '2056',
        //   '2070',
        //   '2094',
        //   '2198',
        //   '2213',
        //   '2241',
        //   '2272',
        //   '2317',
        //   '2364',
        //   '2397',
        //   '2507',
        //   '1110',
        //   '0132',
        //   '2421',
        //   '0291',
        //   '1740',
        //   '0096',
        //   '0100',
        //   '0102',
        //   '0108',
        //   '0110',
        //   '0161',
        //   '0166',
        //   '0188',
        //   '0190',
        //   '0191',
        //   '0234',
        //   '0261',
        //   '0265',
        //   '0282',
        //   '0283',
        //   '0322',
        //   '0334',
        //   '0339',
        //   '0344',
        //   '0372',
        //   '0397',
        //   '0398',
        //   '0413',
        //   '0437',
        //   '0525',
        //   '0526',
        //   '0569',
        //   '0570',
        //   '0580',
        //   '0600',
        //   '0612',
        //   '0623',
        //   '0643',
        //   '0661',
        //   '0678',
        //   '0786',
        //   '1253',
        //   '1255',
        //   '1256',
        //   '1281',
        //   '1300',
        //   '1310',
        //   '1341',
        //   '1377',
        //   '1399',
        //   '1445',
        //   '1454',
        //   '1455',
        //   '1461',
        //   '1471',
        //   '1480',
        //   '1490',
        //   '1537',
        //   '1562',
        //   '1573',
        //   '1574',
        //   '1576',
        //   '1605',
        //   '1611',
        //   '1618',
        //   '1635',
        //   '1642',
        //   '1644',
        //   '1671',
        //   '1686',
        //   '1724',
        //   '1742',
        //   '1762',
        //   '1772',
        //   '1802',
        //   '1822',
        //   '1836',
        //   '1891',
        //   '1896',
        //   '1897',
        //   '1905',
        //   '1948',
        //   '1955',
        //   '1968',
        //   '1993',
        //   '1994',
        //   '1996',
        //   '2013',
        //   '2019',
        //   '2192',
        //   '2193',
        //   '2204',
        //   '2219',
        //   '2221',
        //   '2244',
        //   '2248',
        //   '2255',
        //   '2261',
        //   '2285',
        //   '2287',
        //   '2291',
        //   '2303',
        //   '2349',
        //   '2352',
        //   '2362',
        //   '2390',
        //   '2405',
        //   '2480',
        //   '2509',
        //   '2510',
        //   '2515',
        //   '2523']

        //this.doPopUp = this.remember; // = !(myNotShops.includes(this.myDataShop?.Key));

        //this.slaInternal = "";

        //this.isCsTeam().subscribe(isTeam => {
        //  if (isTeam) {
        //    this.slaInternal = this.myDataShop?.SlaInternal
        //  }
        //});

        this.shopService.emitShop(this.myDataShop);
      });
  }


isCsTeam(): Observable < boolean > {
      return this.userService.role().pipe(
        map(res => res === 'citipostsuperadmin' || res === 'citipostadmin')
      );
    }




  getUserLocal() {
    this.loaderService.emitChange(true);
    var myUrl: string = '/Users/AuthedUser';
    this.http.get(myUrl)
      .subscribe((res: any) => {
        this.loaderService.emitChange(false);
        //this.myDataShop = res[0];
        this.userName = 'Welcome ' + res.Firstname + ' ' + res.Lastname;
      });
  }


  myPopUpList: any = []


  lensdispatchErr = ""

  trakiErr= ""
    public ngOnInit(): any {
      this.shop = localStorage.getItem("Shop");

      //this.doPopUp = true;

      const lensdispatchErrMessage = this.route.snapshot.queryParamMap.get('lensdispatcherr');
      this.lensdispatchErr = lensdispatchErrMessage ? ' <b>Lens Dispatch</b> '+ lensdispatchErrMessage : ''

      const errMessage = this.route.snapshot.queryParamMap.get('trakiierr');
      this.trakiErr = errMessage ? errMessage+ ' (Trakii)': ''
   
      this.getShopLocal(this.shop); 
      this.shopService.emitChange(this.shop); //need to set this first
      this.getUserLocal();
    }
}
